import {ApplicationUserDto, ApplicationUserRegisterDto, ApplicationUserRole} from "../../../api";
import {CrudFormItemProps, CrudFormModal, nameof} from "digimuth-components/dist";
import {Input, Select, Switch} from "antd";
import FirstAndLastName from "../../../components/formComponents/firstAndLastName/firstAndLastName";
import React from "react";

export const enumRoles = [
    {label: "Administrator", value: ApplicationUserRole.Admin},
    {label: "Menedżer Menu", value: ApplicationUserRole.MenuManager},
    {label: "Menedżer Wiadomości", value: ApplicationUserRole.NewsManager},
    {label: "Menedżer Piwa", value: ApplicationUserRole.BeerManager},
    {label: "Menedżer Produktów", value: ApplicationUserRole.ProductManager},
    {label: "Menedżer Zamówień", value: ApplicationUserRole.OrderManager}
];

export default function UserModalForm(props: UserModalFormProps) {
    const formItems: CrudFormItemProps[] = [
        {
            name: "firstAndLastName",
            label: "Imię i nazwisko",
            rules: [
                {required: true, message: "To pole jest wymagane"},
                {
                    validator: (_, value) => {
                        if (!value || value.firstName && value.lastName) return Promise.resolve();
                        if (value.firstName && !value.lastName) {
                            return Promise.reject(new Error("Nazwisko jest wymagane"));
                        }
                        if (!value.firstName && value.lastName) {
                            return Promise.reject(new Error("Imię jest wymagane"));
                        }
                    }
                }
            ],
            children: <FirstAndLastName initialValues={{
                firstName: props.initialValues?.firstName,
                lastName: props.initialValues?.lastName
            }}/>
        },
        {
            name: nameof<ApplicationUserRegisterDto>("phoneNumber"),
            label: "Numer telefonu",
            rules: [
                {required: true, message: 'To pole jest wymagane'},
            ]
        },
        {
            name: nameof<ApplicationUserRegisterDto>("email"),
            label: "Email",
            rules: [
                {required: true, message: 'To pole jest wymagane'},
                {type: 'email', message: 'Format adresu email jest niepoprawny'}
            ],
            children: <Input disabled={props.initialValues !== null}/>
        },
        {
            name: nameof<ApplicationUserRegisterDto>("newsletter"),
            label: "Newsletter",
            valuePropName: "checked",
            children: <Switch/>
        },
        {
            name: nameof<ApplicationUserRegisterDto>("roles"),
            label: "Role",
            rules: [
                {required: true, message: 'To pole jest wymagane'},
            ],
            children: <Select mode="multiple" showSearch placeholder="Wybierz role" options={enumRoles}/>
        }
    ]

    const onSubmit = async (values: any) => {
        values.firstName = values.firstAndLastName.firstName;
        values.lastName = values.firstAndLastName.lastName;

        await props.onSubmit(values);
    }

    return <CrudFormModal
        isModalVisible={props.isModalVisible}
        modalTitle={props.modalTitle}
        forceRender={true}
        destroyOnClose={true}
        formItems={formItems}
        modalOkText={props.saveButtonTitle}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        onSubmit={onSubmit}
        modalCancelText={props.cancelButtonTitle}
        initialValues={{
            "firstAndLastName": {
                firstName: props.initialValues?.firstName,
                lastName: props.initialValues?.lastName
            },
            ...props.initialValues
        }}
        width={700}
        formProps={{
            labelCol: {span: 24},
            wrapperCol: {span: 24},
            layout: 'vertical'
        }}
    />
}

interface UserModalFormProps {
    initialValues?: ApplicationUserDto | ApplicationUserRegisterDto,
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: ApplicationUserRegisterDto | ApplicationUserDto) => Promise<any>,
    saveButtonTitle: string,
    cancelButtonTitle: string,
    modalTitle: string;
}
